import { render, staticRenderFns } from "./SearchSection.vue?vue&type=template&id=15765654&scoped=true&"
import script from "./SearchSection.vue?vue&type=script&lang=js&"
export * from "./SearchSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchSection.vue?vue&type=style&index=0&id=15765654&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15765654",
  null
  
)

export default component.exports